import * as yup from 'yup'

export default yup.object({
  email: yup.string().email('Correo inválido. Verifique la dirección.').required('Correo requerido.'),
  password: yup.string().required('Contraseña requerida.')
})
